module.exports = __webpack_public_path__ + "img/desain-grafika-major.b4edcda4.png";